// The video editor's timeline strings (components/Editor), under t('editor.rve.timeline.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  // Header: undo / redo
  undoTitle: 'Deshacer (Ctrl/Cmd + Z)',
  undoLabel: 'Deshacer la última acción',
  redoTitle: 'Rehacer (Ctrl/Cmd + Shift + Z)',
  redoLabel: 'Rehacer la última acción',
  // Header: splitting
  selectItemToSplit: 'Selecciona un elemento para dividirlo en el cabezal',
  selectOneItemToSplit: 'Selecciona solo un elemento para dividir',
  movePlayheadToSplit: 'Mueve el cabezal sobre el elemento seleccionado para dividirlo',
  splitSelectedItem: 'Dividir el elemento seleccionado en el cabezal',
  clickItemsToSplit: 'Haz clic en los elementos de la línea de tiempo para dividirlos',
  enableSplittingMode: 'Activar modo de división',
  autoRemoveEmptyTracks: 'Quitar pistas vacías automáticamente',
  enableAutoRemoveEmptyTracks: 'Activar la eliminación automática de pistas vacías',
  // Header: playback
  jumpToStart: 'Ir al inicio',
  jumpToEnd: 'Ir al final',
  playVideo: 'Reproducir video',
  pauseVideo: 'Pausar video',
  // Header: aspect ratio
  aspectRatio: 'Relación de aspecto',
  widescreen: 'Panorámico',
  vertical: 'Vertical',
  square: 'Cuadrado',
  portrait: 'Retrato',
  // Header: zoom and collapse
  zoomOut: 'Alejar',
  zoomIn: 'Acercar',
  resetZoom: 'Restablecer zoom',
  timelineZoom: 'Zoom de la línea de tiempo',
  expandTimeline: 'Expandir línea de tiempo',
  collapseTimeline: 'Contraer línea de tiempo',
  // Track handles
  reorderTrack: 'Reordenar pista',
  enableMagnetic: 'Activar línea de tiempo magnética',
  disableMagnetic: 'Desactivar línea de tiempo magnética',
  deleteTrack: 'Eliminar pista',
  gapTitle: 'Espacio: {start}s - {end}s (haz clic para cerrarlo)',
  // Item context menu
  duplicate: 'Duplicar',
  duplicateItems: 'Duplicar {n} elementos',
  splitAtPlayhead: 'Dividir en el cabezal',
  delete: 'Eliminar',
  deleteItems: 'Eliminar {n} elementos',
  // Item labels
  videoLabel: 'VIDEO',
  imageLabel: 'IMAGEN',
  textLabel: 'TEXTO',
  audioLabel: 'AUDIO',
  captionLabel: 'SUBTÍTULO',
  subtitlesLabel: 'Subtítulos',
  stickerLabel: 'STICKER',
  blurLabel: 'DESENFOQUE',
  blurLevelLabel: 'DESENFOQUE ({n}px)',
  unknownLabel: 'Desconocido',
  typeLabel: 'Tipo: {type}',
  loading: 'Cargando...',
  noWaveform: 'Sin forma de onda',
  // Shared editor UI (ui/dialog, ui/sidebar)
  close: 'Cerrar',
  toggleSidebar: 'Mostrar u ocultar barra lateral',
};
